import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getHeaderTitle", "actionMetadata", "actionId"];
import PropTypes from 'prop-types';

// @ts-expect-error untyped module
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import Action from 'automation-ui-action-features/records/Action';
import WaitUntilActionSummary from 'automation-ui-action-features/actions/wait-until/WaitUntilActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
function WaitUntilActionCard(_ref) {
  let {
      getHeaderTitle,
      actionMetadata,
      actionId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: /*#__PURE__*/_jsx(WaitUntilActionSummary, {
      actionMetadata: actionMetadata,
      getActionLabelById: getHeaderTitle
    })
  }));
}
WaitUntilActionCard.propTypes = {
  action: PropTypes.instanceOf(Action).isRequired,
  dataSourceAction: PropTypes.instanceOf(Action),
  flowObjectTypeId: ObjectTypeIdType,
  getHeaderTitle: PropTypes.func.isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default WaitUntilActionCard;